import capitalize from "lodash/capitalize";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface CategoryButtonProps {
  isActive: boolean;
  name: string;
  nameI18n?: string;
  onClick: () => void;
}

export const CategoryButton = ({
  name,
  nameI18n,
  isActive,
  onClick,
}: CategoryButtonProps) => (
  <li key={name}>
    <button
      type="button"
      className={classNames(
        "text-xs-plus text-dark h-8.5 hover:bg-overlay-dark flex w-full items-center rounded-lg px-3 py-2 text-left font-medium transition-colors",
        {
          "bg-overlay-dark": isActive,
        },
      )}
      onClick={onClick}
    >
      {nameI18n
        ? t(nameI18n, { defaultValue: capitalize(name) })
        : capitalize(name)}
    </button>
  </li>
);
